export const FETCHING_CATEGORIES = "FETCHING_CATEGORIES";
